<template>
    <div>
        <!--Start Middle content-->
        <!--Start internal page banner section-->
        <section class="internal-page-banner-main col-12">
            <div class="container">
                <div class="row">
                    <div class="page-title">
                        <h1> Surveys
                            <div v-if="role.id <= 1" class="col-12 col-sm-12 col-md-2 col-lg-2 pull-right">
                                <v-select class=""
                                          v-model="locationId"
                                          name="locationId"
                                          id="locationData"
                                          label="text"
                                          :clearable="false"
                                          :searchable="false"
                                          :filterable="false"
                                          :options="locationArr"
                                          placeholder="Select State">
                                </v-select>
                            </div>
                            <div v-if="role.id <= 1" class="col-12 col-sm-12 col-md-2 col-lg-2 pull-right">
                                <v-select class=""
                                          v-model="roleId"
                                          name="roleId"
                                          id="roleData"
                                          label="text"
                                          :clearable="false"
                                          :searchable="false"
                                          :filterable="false"
                                          :options="roleArr"
                                          placeholder="Select Role">
                                </v-select>
                            </div>
                        </h1>
                    </div>
                </div>
            </div>
        </section>
        <!--End internal page banner section-->
        <div class="internal-page-main-section survey-section-main col-12">
            <div class="container">
                <div class="row">
                    <div class="survey-main-section col-12 float-l">
                        <div class="row">
                            <div class="">
                                <template v-for="(text, index) in surveyList">
                                <div class="survey-detail-section col-12 col-sm-4 col-md-4 col-lg-4"> <!--first-->
                                    <div class="survey-inner-sec">
                                        <div class="survey-title float-l width-full">
                                            <h3> {{text.title}} </h3>
                                        </div>
                                        <div class="survey-img float-l width-full">
                                            <img class="width-full" :src="text.image_path" alt="Survey">
                                        </div>
                                        <div class="survey-short-des float-l width-full">
                                            <p v-html="text.description"></p>
                                        </div>
                                        <div class="survey-pdf-section float-l width-full">
                                            <template v-for="(btn, index) in text.button_array">
                                            <!-- <a :href="btn.button_url" target="_blank"> {{btn.button_title}} </a> -->
                                                <template v-if="btn.button_type == 'url'">
                                                    <a :href="btn.button_url" target="_blank"> {{btn.button_title}} </a>
                                                </template>
                                                <template v-else>
                                                    <a href="#" :id="'id' + index" @click="getSignedUrlPath(btn.button_url)"> {{btn.button_title}} </a>
                                                </template>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                </template>


                                <!--<div class="survey-detail-section col-12 col-sm-4 col-md-4 col-lg-4"> &lt;!&ndash;first&ndash;&gt;
                                    <div class="survey-inner-sec">
                                        <div class="survey-title float-l width-full"> 
                                            <h3> Exit Interview Survey </h3>
                                        </div> 
                                        <div class="survey-img float-l width-full">
                                            <img class="width-full" src="/static/images/survey-deatil-img.jpg" alt="Survey">
                                        </div>
                                        <div class="survey-short-des float-l width-full">
                                            <p> We want to understand why you are leaving in an effort to continuously improve our employee experience. Please click here to take a quick survey so that we can pinpoint what areas we can improve on </p>
                                        </div>
                                        <div class="survey-pdf-section float-l width-full">
                                            <a href="https://www.surveymonkey.com/r/VVGExitInterview" target="_blank"> Exit Interview Survey Form </a>
                                        </div>
                                    </div>            
                                </div>
                                &lt;!&ndash;first&ndash;&gt;
                                <div v-if="role.id == 1" class="survey-detail-section col-12 col-sm-4 col-md-4 col-lg-4"> &lt;!&ndash;second&ndash;&gt;
                                    <div class="survey-inner-sec">
                                        <div class="survey-title float-l width-full"> 
                                            <h3> HR Admin Survey </h3>
                                        </div> 
                                        <div class="survey-img float-l width-full">
                                            <img class="width-full" src="/static/images/survey-hr-img.jpg" alt="Survey">
                                        </div>
                                        <div class="survey-short-des float-l width-full">
                                            <p> We appreciate your assistance with HR Admin duties that you take part in. We created a survey to help distinguish which areas we need to train you in. If you can please answer as honestly as you can so we know what areas we should focus on </p>
                                        </div>
                                        <div class="survey-pdf-section float-l width-full">
                                            <a href="https://www.surveymonkey.com/r/YWX732G" target="_blank"> HR Admin Survey Form </a>
                                        </div>
                                    </div>            
                                </div>
                                &lt;!&ndash;second&ndash;&gt;-->

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--End Middle content-->
    </div>
</template>
<script>
    import Vue from "vue";
    import SessioMixin from '../mixins/sessionmixin';
    import {HTTP} from '../http-common';
    import vSelect from 'vue-select';
    import VueFrame from 'vue-frame';
    var self;
    export default {
        name: 'Surveys',
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
            'v-frame': VueFrame,
        },
        data() {
            return {
                FirstLoad: true,
                roleId: 0,
                roleArr: [],
                locationId: 0,
                locationArr: [],
                surveyList: [],
            }
        },
        beforeMount: function () {
            self = this;
            self.role.id = 0;
            self.checkLogin();
        },
        mounted: function () {
            self.MenuClose();
            self.loadLocations();
            self.loadRole();
            self.getSurveyData();
            self.getPermissions();
            self.getBuildVersion();
        },
        watch: {
            locationId: function (locationId) {
                self.getSurveyData();
            },
            roleId: function (roleId) {
                self.getSurveyData();
            }
        },

        methods: {
            loadLocations() {
                HTTP.post("getlocation")
                    .then(function (response) {
                        self.locationArr = [];
                        /*var addAll = {text: 'All', value: '0'};
                         self.locationArr.push(addAll);*/
                        $.each(response.data.content, function (i) {
                            /*if (response.data.content[i].value != 0) {*/
                            self.locationArr.push(response.data.content[i]);
                            /*}*/
                        });
                        self.locationId = {text: response.data.content[0].text, value: response.data.content[0].value};
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                self.$router.push("/login");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                        }
                    });
            },
            loadRole() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post("getroles", '', config)
                    .then(function (response) {
                        self.roleArr = [];
                        var addAll = {text: 'All', value: '0'};
                        //self.roleArr.push(addAll);
                        $.each(response.data.content, function (i) {
                            self.roleArr.push(response.data.content[i]);
                        });
                        self.roleId = addAll;
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                self.$router.push("/login");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                        }
                    });
            },
            getSurveyData() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var roleId = (self.roleId === null || self.roleId == '') ? 0 : self.roleId.value;
                var locationId = (self.locationId === null || self.locationId == '') ? 0 : self.locationId.value;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        role_id: roleId,
                        location_id: locationId,
                    }
                };

                HTTP.post("getsurveydata", '', config)
                    .then(function (response) {
                        self.surveyList = [];
                        setTimeout(function () {
                            self.surveyList = response.data.content;
                        }, 100);
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            },
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/Surveys.vue